export default __webpack_public_path__ + "static/media/1858.48c995f3.png";